var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CenteredContent",
    { class: _vm.$style.desktopMain },
    [
      _c("Logo", { class: _vm.$style.homeLogo }),
      _vm._v(" "),
      _c("div", { class: _vm.$style.homeTitle }, [_vm._v("\n    Welcome\n  ")]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "BaseButton",
            {
              attrs: { "button-style": "RoundCentered" },
              on: { click: _vm.startHandler }
            },
            [_c("span", [_vm._v("Start Order")])]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/desktop/components/DesktopMain.vue?vue&type=template&id=b2bff2ba&
// module id = null
// module chunks = 